import React from 'react';
import './Header.css';

class Header extends React.Component {
  render() {
    return (
      <header>
        <h1 className="site-title">Currency converter</h1>
      </header>
    );
  }
}

export default Header;
